import { router } from '@inertiajs/react'
import { useEffect, useRef, useState } from 'react'
import type { Props } from '@/frontend/pages/Dashboard/Workflows/types'

export default function useOrganizationReset({ organization, connection, list_path, project }: Pick<Props, 'organization' | 'connection' | 'list_path' | 'project'>) {
  const context = `${organization.id}:${connection.tenant}:${project?.id ?? ''}`
  const previous = useRef(context)
  const [resetting, setResetting] = useState(false)
  const changed = previous.current !== context
  useEffect(() => {
    if (previous.current === context) return
    previous.current = context
    setResetting(true)
    // A new organization starts from its list; old cursor, execution ID and run never carry over.
    router.get(list_path, project ? { project_id: project.id } : {}, { replace: true, preserveState: false, onFinish: () => setResetting(false) })
  }, [context, list_path, project?.id])
  return changed || resetting
}
